import { useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export interface RequestLog {
  _id: string;
  requestId: string;
  sessionId: string;
  requestType: 'inbound' | 'outbound';
  destination?: string;
  request: {
    method: string;
    url: string;
    headers?: any;
    query?: any;
    params?: any;
    body?: any;
    cookies?: any;
    files?: any;
    ip?: string;
  };
  response: {
    status: number;
    headers?: any;
    body?: any;
  };
  startTime?: Date;
  endTime?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface RequestsQueryParams {
  page?: number;
  size?: number;
  sortField?: 'createdAt' | 'updatedAt';
  sortDirection?: 'asc' | 'desc';
  sessionId?: string;
  urlPrefix?: string;
}

export const useRequests = (params: RequestsQueryParams = {}) => {
  const { page = 1, size = 10, sortField = 'createdAt', sortDirection = 'desc', sessionId, urlPrefix } = params;

  return useQuery({
    queryKey: ['admin-requests', page, size, sortField, sortDirection, sessionId, urlPrefix],
    queryFn: async (): Promise<{ data: RequestLog[]; total: number }> => {
      try {
        const queryParams = new URLSearchParams({
          page: page.toString(),
          size: size.toString(),
          sortField,
          sortDirection,
        });

        if (sessionId) {
          queryParams.append('filters[sessionId]', sessionId);
        }

        if (urlPrefix) {
          queryParams.append('filters[urlPrefix]', urlPrefix);
        }

        const response = await request({
          path: `admin/requests?${queryParams.toString()}`,
          method: 'GET',
          authenticate: true,
        });

        return response || { data: [], total: 0 };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch requests');
        return { data: [], total: 0 };
      }
    },
  });
};
